import { FlexColumn } from '../../styles/CommonStyles'
import {
  Body,
  LinkWrapper,
  MenuIconWrapper,
  MLink,
  NavItemWrapper,
  NavText,
  GroupDivider
} from '../../styles/layout-styles/SideBarStyles'
import Text from '../../core/utils/Text'
import { LAPTOP_SIZE, MOBILE_SIZE } from '../../core/constants/common'
import { Link, useLocation } from 'react-router-dom'
import { useWindowSize } from '../../core/hooks/useWindowSize'
import { useMainContext } from '../../core/contexts/main'
import WalletIcon from '../icons/WalletIcon'
import ChartIcon from '../icons/ChartIcon'
import UserGroupIcon from '../icons/UserGroupIcon'
import ArrowSwapIcon from '../icons/ArrowSwapIcon'
import { useTranslation } from 'react-i18next'
import CryptoIcon from '../icons/CryptoIcon'
import ForexIcon from '../icons/ForexIcon'
import StarIcon from '../icons/StarIcon'
import NodesIcon from '../icons/NodesIcon'
import WalletBalance from './widgets/WalletBalance'
import LangSwitcher from '../common/LangSwitcher'
import BellIcon from '../icons/BellIcon'
import { LayoutGroup, motion } from 'framer-motion'
import TelegramIcon from '../icons/Telegram'
import FlashIcon from '../icons/FlashIcon'

const Sidebar = ({ isOpen }) => {
  const { width } = useWindowSize()

  return (
    <>
      {width >= LAPTOP_SIZE && (
        <Body>
          <FlexColumn>
            <WalletBalance />
            <NavGroup title="analyzers" items={analyzers} />
            <GroupDivider />
            <NavGroup title="main-menu" items={mainMenu} />
            <GroupDivider />
            <NavGroup title="preferences" items={[]} />
            <FlexColumn className="px-3 mt-2 gap-2">
              <LangSwitcher position="top" offset={4} />
            </FlexColumn>
          </FlexColumn>
        </Body>
      )}
    </>
  )
}


const NavGroup = ({ title, items }) => {
  const { t } = useTranslation()
  const { main: { lang, theme } } = useMainContext()
  const location = useLocation()
  const { width } = useWindowSize()

  const currentPath = location.pathname

  return (
    <FlexColumn>
      <Text className="text-sm !text-[#DAB2FFB2] uppercase" tid={title} />

      {/* LayoutGroup isolates animation per group */}
      <LayoutGroup id={title}>
        <LinkWrapper resp={width <= MOBILE_SIZE}>
          {items.map((nav) => {
            const isActive = currentPath === nav.route

            return (
              <motion.div
                key={nav.text}
                layout
                className="relative"
              >
                {/* ACTIVE INDICATOR */}
                {isActive && <SidebarIndicator />}

                <Link
                  to={nav.route}
                  data-tooltip-id="main-tooltip"
                  data-tooltip-content={t(nav.text)}
                >
                  <MLink _theme={theme} active={isActive}>
                    <NavItemWrapper data-active={isActive}>
                      <MenuIconWrapper>
                        <nav.icon
                          size={width <= 768 ? 20 : 16}
                          color={isActive ? '#FFFFFF' : '#99A1AF'}
                        />
                      </MenuIconWrapper>

                      <NavText isBold={title === "analyzers" && lang === 'fa'}>
                        <Text
                          tid={nav.text}
                          className={isActive ? 'text-white' : 'text-[#99A1AF]'}
                        />
                      </NavText>
                    </NavItemWrapper>
                  </MLink>
                </Link>
              </motion.div>
            )
          })}
        </LinkWrapper>
      </LayoutGroup>
    </FlexColumn>
  )
}

const SidebarIndicator = () => {
  return (
    <motion.div
      layoutId="sidebar-indicator"
      className="sidebar-indicator"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{
        type: 'spring',
        stiffness: 520,
        damping: 38,
      }}
    />
  )
}

// --- NAVIGATION GROUPS ---
const mainMenu = [
  // { text: 'wallet', route: '/wallet', icon: WalletIcon },
  // { text: 'swap', route: '/swap', icon: ArrowSwapIcon },
  { text: 'plans', route: '/plans', icon: NodesIcon },

  {
    text: 'historys',
    route: '/transactions',
    icon: ChartIcon,
  },

  { text: 'notifications', route: '/notifications', icon: BellIcon },
  { text: 'telegram', route: '/telegram', icon: TelegramIcon },
  { text: 'invite-friends', route: '/invite-friends', icon: UserGroupIcon },
]


const analyzers = [
  { text: 'crypto-analyzers', route: '/analyze/assistant/crypto', icon: CryptoIcon },
  { text: 'forex-analyzers', route: '/analyze/assistant/forex', icon: ForexIcon },
  { text: 'suggestions', route: '/analyze/assistant/suggestions', icon: StarIcon },
  { text: 'fast-scan', route: '/analyze/fastscan/all', icon: FlashIcon },
]

export default Sidebar
